<style scoped>
  
</style>
<template>
  <div class="vfile-uploader">
    <v-menu
      ref="showDateMenu"
      v-model="showDateMenu"
      :close-on-content-click="false" 
      :close-on-click="false"
      transition="scale-transition"
      top
      :offset-x="false"
      min-width="290px"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          :value="(data_arr||[]).map(item=>item.name)"
          :label="label"
          v-bind="attrs"
          readonly
          required
          v-on="on"
        />
      </template>
      <v-card
        class="mx-auto"
        max-width="300"
        tile
      >
        <v-list dense>
          <v-subheader>文件列表</v-subheader>
          <v-list-item
            v-for="(item, i) in (data_arr||[])"
            :key="i"
          >
            <v-list-item-content>
              <v-list-item-title>
                <span 
                  style="cursor:pointer"
                  @click="downloadFile(item)"
                >
                  {{ item.name }}
                </span>
              </v-list-item-title>
            </v-list-item-content>

            <v-list-item-action>
              <v-btn
                icon
                @click="deleteItem(item)"
              >
                <v-icon>
                  mdi-delete-empty
                </v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
          <v-spacer />
          <div style="text-align:right">
            <div
              ref="contain" 
              style="display:none"
            />
            <v-btn
              text
              color="primary"
              :disabled="uploading"
              @click="showDateMenu = false"
            >
              关闭
            </v-btn>
            <v-btn
              text
              color="primary"
              :loading="uploading"
              @click="upload"
            >
              上传附件
            </v-btn>
          </div>
        </v-list>
      </v-card>
    </v-menu>
  </div>
</template>
<script>
// ../../../libs/util
  import Util from '../../../../libs/util';
  import { http } from '../../../../libs/util';
  export default {
    props: {
      value: {
        type: Array,
      },
      label: {
        type: String,
        default: '上传文件'
      },
      multiple: {
        type: Boolean,
        default: true
      },
      upload_path: {
        type: String,
        'default': Util.api.attachment_upload_path
      },
      format: {
        type: Array,
        'default': () => {
          return [];
        }
      },
      file_arr : {
        type: Array,
        default: () => {
          return [];
        }
      },
      model_type: {
        type: String
      },
      model_id: {
        type: String
      }
    },
    data() {
      this.test = [(val) => {
        return val || '测试'
      }]
      return {
        file: null,
        new_file: {
          bfile_id: 0,
          name: '',
          desc: '',
          is_dir: false
        },
        uploading: false,
        share_customers: [],
        search_customer_text: '',
        search_customer_results: [],
        // 
        showDateMenu: false,
        data_arr:this.value,
        delete_load_hash: {}
      }
    },
    computed: {
      //
    },
    watch: {
      data_arr(value) {
        this.$emit('input', value)
      },
      value(newVal) {
        this.data_arr = newVal
      },
    },
    created() {
      //
    },
    mounted() {
      //
    },
    methods: {
      deleteItem(file) {
        if (this.model_id === undefined) {
          this.data_arr.splice(this.data_arr.indexOf(file), 1)
          return 
        }
        this.$Modal.confirm({
          title: '删除确认',
          content: `你确定要删除 ${file.name} 吗?`,
          onOk:() => {
            this.$set(this.delete_load_hash, file.id, true)
            this.$util.ajax.post(this.$util.api.delete_model_file, {
              bfile_id: file.id,
              link_model_type: this.model_type,
              link_model_id: this.model_id
            }).then((response) => {
              return response.data;
            }).then((res) => {
              if (res.code === 1) {
                this.data_arr.splice(this.data_arr.indexOf(file), 1)
                this.$Message.success('删除成功!');
              } else {
                this.$Modal.error({title: '提示', content: res.msg});
              }
            }).catch((e) => {
              this.$Modal.error({title: '提示', content: e.message});
            }).finally(() => {
              this.delete_load_hash[file.id] = false
            });
          }
        });
      },
      upload() {
        this.el = document.createElement('input')
        this.el.setAttribute('type', 'file')
        this.$refs.contain.appendChild(this.el)
        this.el.click()
        this.el.addEventListener('change', this.uploadFile)
      },
      uploadFile() {
        const file = this.el.files[0]
        console.log(file)
        const arr = (this.format || []).map(item => new RegExp(item + '$'))
        if (arr.some(item => (item.test(file.type) || item.test(file.name)))) {
          if (file.name.indexOf('%') > -1) {
            this.$Modal.error({
              title: '提示',
              content: '文件名不能包含百分号%'
            });
            return
          }
          this.$emit('start');
          this.uploading = true
          const formData = new FormData();
          formData.append('file', file)
          http.post_upload(this.upload_path, { formData }).then((res) => {
            if (!this.data_arr) {
              this.data_arr = []
            }
            this.data_arr.push(res.file)
            this.$emit('done', res);
            this.$emit('uploaded', res.file);
          }).finally(() => {
            this.$emit('finally');
            this.uploading = false
          })
        } else {
          this.$Modal.error({
            title: '提示',
            content: `请上传${this.format.join('、')}格式文件`
          })
        }
        this.el.removeEventListener('change', this.uploadFile)
        const childrenInputs = this.$refs.contain.childNodes
        for (let i = 0, len = childrenInputs.length; i < len; i++) {
          this.$refs.contain.removeChild(childrenInputs[i])
        }
        this.el = null
      },
      downloadFile(params) {
        return Util.downloadToBlank({
          id:params.id
        })
      }
    }
  }
</script>
